export default __webpack_public_path__ + "static/media/a024-2.5b71be9d.svg";